






































import { Component, Vue } from 'vue-property-decorator'
import { Designer } from '../../types/designers'
import { getDesigners } from '../../utils/http-client/designer-api'
import DesignerCard from '../../components/DesignerComponents/DesignerCard.vue'

@Component({
  components: {
    DesignerCard
  }
})
export default class DesignersView extends Vue {
  private isLoading: boolean = true
  private error: string = ''
  private designers: Designer[] = []

  async created () {
    this.isLoading = true
    try {
      this.designers = await getDesigners()
    } catch (err) {
      console.error('loading designers Error:', err)
      this.error = 'There was an error loading designers'
    } finally {
      this.isLoading = false
    }
  }
}
